import { saveChatUserToSession } from './saveChatUserToSession'

/**
 *
 * @param {LCChatUser} payload
 */
export function handleChatUserData(payload) {
  saveChatUserToSession(payload)
}
